import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
export default {
  components: {
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput
  },
  layout: Layout,
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        region: null,
        country: null,
        postal_code: null
      })
    };
  },
  methods: {
    store: function store() {
      this.form.post('/organizations');
    }
  }
};